export const makeBlur = () => {
    const elements = document.querySelectorAll('.js--blur');
    elements.forEach((el) => {
        el.blur();
    });
};
